import type { AnalyticsEvent } from "@octopusdeploy/portal-analytics";

interface DeploymentPermissionsReportGeneratedEventProperties {
    selectedEnvironmentsCount: number;
}

interface CreateReportEvent extends AnalyticsEvent<"Create Report"> {
    ReportName: string;
    SelectedEnvironmentsCount: number;
}

export function createCreateReportEvent(properties: DeploymentPermissionsReportGeneratedEventProperties): CreateReportEvent {
    return {
        eventName: "Create Report",
        ReportName: "Deployment Permissions",
        SelectedEnvironmentsCount: properties.selectedEnvironmentsCount,
    };
}

interface DeploymentPermissionsCSVExportedEventProperties {
    selectedEnvironmentsCount: number;
}

interface ExportReportCSVEvent extends AnalyticsEvent<"Export Report CSV"> {
    ReportName: string;
    SelectedEnvironmentsCount: number;
}

export function createExportReportCSVEvent(properties: DeploymentPermissionsCSVExportedEventProperties): ExportReportCSVEvent {
    return {
        eventName: "Export Report CSV",
        ReportName: "Deployment Permissions",
        SelectedEnvironmentsCount: properties.selectedEnvironmentsCount,
    };
}
